"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSecuredMfaVerifiedAtLogin = exports.hasSecuredMfa = void 0;
const dates_1 = require("./dates");
const hasSecuredMfa = (user, organization) => {
    const tfaActivationDates = [user.smsMfaActivationDate, user.totpMfaActivationDate].filter((date) => Boolean(date));
    if (tfaActivationDates.length === 0) {
        return false;
    }
    const tfaSetupDate = new Date(Math.min(...tfaActivationDates.map((date) => date.getTime())));
    const isOlderThan180Days = tfaSetupDate < (0, dates_1.getDateMinusNDays)(new Date(), 180);
    const wasSetupBeforeStripeAccount = organization.stripeCustomAccountActiveAtUtc && tfaSetupDate <= organization.stripeCustomAccountActiveAtUtc;
    return isOlderThan180Days || Boolean(wasSetupBeforeStripeAccount);
};
exports.hasSecuredMfa = hasSecuredMfa;
const hasSecuredMfaVerifiedAtLogin = (user, organization) => {
    const { loginMfaActivationDate, lastSuccessfulSignInAtUtc } = user;
    if (!loginMfaActivationDate || !lastSuccessfulSignInAtUtc) {
        return false;
    }
    return lastSuccessfulSignInAtUtc > loginMfaActivationDate && (0, exports.hasSecuredMfa)(user, organization);
};
exports.hasSecuredMfaVerifiedAtLogin = hasSecuredMfaVerifiedAtLogin;
